var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { TranslationService } from "../../../domain/common";
import { IntelligentPhotoCaptureViewType, usePhotoCaptureEstimatorWorker, usePhotoCaptureWorker as useIntelligentPhotoCaptureWorker, IntelligentConnectedPhotoCaptureAddCommentView, ConnectedIntelligentPhotoCaptureImageAnalyzerView, ConnectedIntelligentPhotoCaptureCameraView, ConnectedIntelligentPhotoCaptureEstimatorVinDecodeView, ConnectedIntelligentPhotoCapturePhotoPreview, ConnectedIntelligentRetakePageView, ConnectedIntelligentVinDecodeComponent, createPersonaConfigManager, ConnectedIntelligentPhotoCaptureEstimatorCameraView, ConnectedIntelligentPhotoCaptureEstimatorThumbnailGallery, IntelligentAssignmentSummary, ConnectedIntelligentAssignmentSummaryEditHandlerComponent } from "../../../domain/photoCapture";
export const IntelligentPhotoCaptureInitComponent = props => {
    const { view, children, appTheme, warningMessage, vinErrorState, sequenceScreenName } = props;
    const { isEnabled } = createPersonaConfigManager(props.personaConfiguration);
    const workerProps = __rest(useIntelligentPhotoCaptureWorker(Object.assign(Object.assign({}, props), { questionSubType: props.questionSubType, isEnabled })), []);
    const estimatorWorker = usePhotoCaptureEstimatorWorker({
        attachmentBatchActivityInfo: props.attachmentBatchActivityInfo,
        attachmentIterationInfo: props.attachmentIterationInfo,
        fileSizeLimit: props.fileSizeLimit,
        maxFileCount: props.maxFileCount,
        companyCode: props.companyCode,
        contextId: props.contextId,
        estimatedSummaryFilesInfo: props.estimatedSummaryFilesInfo,
        estimatorSelectedTileId: props.estimatorSelectedTileId,
        instanceReferenceId: props.instanceReferenceId,
        questionSubType: props.questionSubType,
        signalRConnectionId: props.signalRConnectionId,
        isSignalRConnected: props.isSignalRConnected,
        isSignalRConnectionFailed: props.isSignalRConnectionFailed,
        isPolling: props.isPolling,
        imageMaxWidth: props.imageMaxWidth,
        maxPhotoLimitForBatch: props.maxPhotoLimitForBatch,
        tempAttachmentInfo: props.tempAttachmentInfo,
        userVehicleInfo: props.userVehicleInfo,
        vehicle: props.vehicle,
        estimatorConfiguration: props.estimatorConfiguration,
        onAddAttachmentIteration: props.onAddAttachmentIteration,
        onResetInvalidFileUpload: props.onResetInvalidFileUpload,
        onInvalidFileUpload: props.onInvalidFileUpload,
        onUpdateIterationStatus: props.onUpdateIterationStatus,
        onEstimatorUpload: props.onEstimatorUpload,
        onUpdateCameraFileStatus: props.onUpdateCameraFileStatus,
        onUpdateIterationBatchCount: props.onUpdateIterationBatchCount,
        onTakePhotoUploadSuccess: props.onTakePhotoUploadSuccess,
        onDeleteAllAttachmentIterations: props.onDeleteAllAttachmentIterations,
        onRequestDamageConnection: props.onRequestDamageConnection,
        onRequestDamageDetection: props.onRequestDamageDetection,
        onUpdateIterationDamageCallStatus: props.onUpdateIterationDamageCallStatus,
        onUpdateUserVehicleInfo: props.onUpdateUserVehicleInfo,
        photoCaptureDeleteAttachmentsAction: props.photoCaptureDeleteAttachmentsAction,
        photoCaptureUploadAttachmentsAction: props.photoCaptureUploadAttachmentsAction
    });
    const [selectedImage, setSelectedImage] = React.useState({});
    const translateFn = TranslationService.translate;
    const getView = () => {
        switch (view) {
            case IntelligentPhotoCaptureViewType.CAMERA: {
                return (React.createElement(ConnectedIntelligentPhotoCaptureCameraView, { appTheme: appTheme, setSelectedImage: setSelectedImage, updatePageAttachmentHistory: workerProps.updatePageAttachmentHistory }));
            }
            case IntelligentPhotoCaptureViewType.PREVIEW: {
                return (React.createElement(ConnectedIntelligentPhotoCapturePhotoPreview, { appTheme: appTheme, translateFn: translateFn, language: TranslationService.getCurrentLanguage(), selectedImage: selectedImage, updatePageAttachmentHistory: workerProps.updatePageAttachmentHistory }));
            }
            case IntelligentPhotoCaptureViewType.COMMENT: {
                return (React.createElement(IntelligentConnectedPhotoCaptureAddCommentView, Object.assign({ appTheme: appTheme, translateFn: translateFn, selectedImage: selectedImage, setSelectedImage: setSelectedImage }, workerProps)));
            }
            case IntelligentPhotoCaptureViewType.RETAKE_PAGE: {
                return (React.createElement(ConnectedIntelligentRetakePageView, { appTheme: appTheme, selectedImage: selectedImage, translateFn: translateFn, updatePageAttachmentHistory: workerProps.updatePageAttachmentHistory }));
            }
            case IntelligentPhotoCaptureViewType.IMAGE_IQA: {
                return (React.createElement(ConnectedIntelligentPhotoCaptureImageAnalyzerView, { appTheme: appTheme, selectedImage: selectedImage, updatePageAttachmentHistory: workerProps.updatePageAttachmentHistory }));
            }
            case IntelligentPhotoCaptureViewType.VIN_DECODE: {
                return (React.createElement(ConnectedIntelligentVinDecodeComponent, { appTheme: appTheme, warningMessage: warningMessage, updatePageAttachmentHistory: workerProps.updatePageAttachmentHistory, isEnabled: isEnabled, vinErrorState: vinErrorState }));
            }
            case IntelligentPhotoCaptureViewType.ESTIMATOR_CAMERA: {
                return React.createElement(ConnectedIntelligentPhotoCaptureEstimatorCameraView, { appTheme: appTheme });
            }
            case IntelligentPhotoCaptureViewType.ESTIMATOR_GALLERY: {
                return (React.createElement(ConnectedIntelligentPhotoCaptureEstimatorThumbnailGallery, { appTheme: appTheme, initialSelectedTileId: props.estimatorSelectedTileId || 0, isReviewMode: sequenceScreenName === IntelligentAssignmentSummary.REVIEW, estimatorWorker: estimatorWorker }));
            }
            case IntelligentPhotoCaptureViewType.ESTIMATOR_VIN_DECODE: {
                return (React.createElement(ConnectedIntelligentPhotoCaptureEstimatorVinDecodeView, { appTheme: appTheme, warningMessage: warningMessage }));
            }
            case IntelligentPhotoCaptureViewType.ESTIMATOR_ODOMETER_LICENSE_PLATE_EDIT: {
                return React.createElement(ConnectedIntelligentAssignmentSummaryEditHandlerComponent, { appTheme: appTheme });
            }
            default: {
                return React.cloneElement(children, Object.assign(Object.assign({}, workerProps), { estimatorWorker, selectedImage, setSelectedImage }));
            }
        }
    };
    return React.createElement(React.Fragment, null, getView());
};
//# sourceMappingURL=IntelligentPhotoCaptureInitComponent.js.map